import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { Link } from 'react-router-dom';
import { SectionHeader_2, Card_6 } from '../../../../../component/landingComponent';
const PlDeveloperGuide = () => {
    return (
        <div className='row mt-20  pb-5'>
            <div className="col-md-12 text-center mb-6">
                <SectionHeader_2
                    title= {`Developer Guide`}
                />
            </div>
            <div className="cta-area-wrapper px-20  pt-0 bg-none">
                <div className="section-heading">
                    <div className="text-wrapper">
                        <p className="text has_fade_anim mt-3 fs-1  text-grad-3" >Login into TruVoice console to access all the guides.</p>
                    </div>
                    <div className="btn-wrap has_fade_anim mt-10" >
                        <Link
                            to="/sign-up" 
                            className="wc-btn wc-btn-primary bordered btn-text-flip p-5 me-5 fs-4 w-50"
                        >
                            <span data-text="Sign up now">Sign up now</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export {PlDeveloperGuide}